export const triggerButtonRetryDuration = 500
export const triggerButtonRetryTimeout = 5000
export const triggerButtonId = 'tdl-booking-start'
export const widgetHolderId = 'tdl-booking-widget'
export const widgetMyBookingId = 'tdl-my-bookings-widget'
export const stickyHeaderClassName = 'calculate-sticky-header-for-widget'
export const iframeOrigin = import.meta.env.VITE_WIDGET_URL || '/'
export const allowedOrigins = [
  iframeOrigin,
  ...(!import.meta.env.PROD
    ? [
        'http://localhost:8080',
        'http://localhost:8081',
        'http://localhost:9090',
        'http://localhost:3030',
        'http://localhost:3000',
      ]
    : []),
]

export const stockholmSubAreas = [
  'Kista',
  'Farsta',
  'Nacka',
  'Danderyd',
  'Täby',
  'Sollentuna',
  'Sundbyberg',
  'Norsborg',
  'Skärholmen',
  'Skogås',
]

export const gbgSubAreas = ['Mölndal']

export const defaultBullets = [
  'Korta väntetider',
  'Samma pris sju dagar i veckan',
  'Lång erfarenhet av tandvårdsrädsla',
]

export const featureName = {
  progressBar: 'progress-bar',
  phoneCall: 'phone-call',
  upcomingAppointments: 'upcoming-appointments',
  priceAppointmentCard: 'price-appointment-card',
  bookingAlert: 'booking-alert',
  appointmentCaregiverImage: 'appointment-caregiver-image',
  promoSection: 'promo-section',
} as const

export const rudderstackErrors = {
  MISSED_REQUIRED_FIELD: 'MISSED_REQUIRED_FIELD',
  FINAL_OR_ORIGINAL_PRICE_IS_UNDEFINED: 'FINAL_OR_ORIGINAL_PRICE_IS_UNDEFINED',
  FINAL_PRICE_IS_GREATER_THAN_REDUCED_PRICE:
    'FINAL_PRICE_IS_GREATER_THAN_REDUCED_PRICE',
  UNKNOWN_RESPONSE_ERROR: 'UNKNOWN_RESPONSE_ERROR',
  FOR_NEW_PATIENT_BUT_PATIENT_EXIST: 'FOR_NEW_PATIENT_BUT_PATIENT_EXIST',
  FOR_EXISTING_PATIENT_BUT_PATIENT_DOES_NOT_EXIST:
    'FOR_EXISTING_PATIENT_BUT_PATIENT_DOES_NOT_EXIST',
} as const
